import React from 'react';
import BaseApi from '../../api/BaseApi.js';
import ScreenCaption from '../screen-caption.js';


export default class RefScreen extends React.Component {

    constructor(props) {
        super(props);

        var refrecid = null

        if (this.props.args.refrecid) {
            refrecid = this.props.args.refrecid
        }

        this.state = { currentRef: {id: null,
                                    refrecid: refrecid,            
                                    name: "",
                                    ref: ""}};

        this.handleChangeName = this.handleChangeName.bind(this);  
        this.handleChangeRef = this.handleChangeRef.bind(this);  
        this.save = this.save.bind(this);                         
    }

    async componentDidMount() {

        if (this.props.args.ref && this.props.args.ref.length > 0) {
            BaseApi.get("/ref", {headers: {
                'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: {id: this.props.args.ref}, withCredentials: true})
            .then(res => { 
                this.setState({currentRef: res.data})
            })    
            .catch()
        }
    }


    save(event) {
        BaseApi.post('/ref', this.state.currentRef, {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => {
            this.props.goback(this.props.args)
        })
        .catch(error=>console.log(error))
        
        event.preventDefault();
    }

    handleChangeName(event) {
        var currentRef = this.state.currentRef
        currentRef.name = event.target.value
        this.setState({currentRef: currentRef})
    }

    handleChangeRef(event) {
        var currentRef = this.state.currentRef
        currentRef.ref = event.target.value
        this.setState({currentRef: currentRef})
    }


    render() {
    
        return (
            <div class="container">
                <ScreenCaption goback={this.props.goback} args={this.props.args} caption={"Ссылка"}/>
                <div class="row mt-5">
                    <div class="col-md-6">
                        <form>
                            <div class="form-group">
                                <label for="name"> Наименование:</label>
                                <input type="text" class="form-control w-100" id="name" value={this.state.currentRef.name} onChange={this.handleChangeName} />
                            </div>
                            <div class="form-group">
                                <label for="name">Ссылка:</label>
                                <input type="text" class="form-control w-100" id="name" value={this.state.currentRef.ref} onChange={this.handleChangeRef} />
                            </div>
                        </form>
                    </div>
                    <div class="col-md-3 offset-3">
                        <div class="row mt-3">
                            <button class="btn btn-primary w-100" onClick={this.save}>Сохранить</button>   
                        </div>
                    </div>
                </div>
            </div> 
        )
    }

}


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/ref-screen.js